import { StripePromotionCodeClient } from 'api/clients/StripePromotionCodeClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery } from 'react-query'

export const usePromotionCode = (promotionCode?: string) =>
  useQuery(
    ['promotion_code', promotionCode],
    async () => {
      if (!promotionCode) return

      const res = await StripePromotionCodeClient.get(promotionCode)

      if (res.type === SUCCESS_RESPONSE_TYPE) {
        return res.data
      } else {
        throw new Error('Error fetching promotion code')
      }
    },
    {},
  )
